import dynamic from 'next/dynamic';

import { showsSimilarPropertiesButton } from '@/utils/propertyDataUtils';
import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useExposePageProps } from '@/hooks/useExposePageProps';
import { useSimilarListings } from '@/hooks/queries/useSimilarListings';
import { useListing } from '@/hooks/queries/useListing';

const SimilarPropertiesButton = dynamic(() =>
  import('@/components/property-expose/SimilarPropertiesButton/SimilarPropertiesButton').then((mod) => mod.SimilarPropertiesButton),
);

export const DynamicSimilarPropertiesButton = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing, genericListing },
  } = useListing();
  const { pageVariant } = useExposePageProps();
  const { data: similarListings } = useSimilarListings();

  const isPrivateOffice = pageVariant.includes('private-office');
  const shouldShowButton = isPrivateOffice
    ? Boolean(genericListing.agent?.id && similarListings?.length)
    : !listing || showsSimilarPropertiesButton(listing);

  if (!shouldShowButton || isUAExclusiveListingAndNotSignedIn) return null;

  return <SimilarPropertiesButton />;
};
